import intl from 'react-intl-universal';
import { DASHBOARD_DETAIL_ACTIONS } from '../../../../utils/constants/dashboard';
import { useCallback, useContext, useState } from 'react';
import DeleteDashboardModal from '../../../../Organisms/DeleteDashboardModal/DeleteDashboardModal';
import { useSelector } from 'react-redux';
import { RootState, useAppThunkDispatch } from '../../../../state/store';
import {
  dashboardSelectors,
  deleteDashboard,
} from '../../../../state/normalized/dashboard/dashboardSlice';
import { DashboardContext } from '../../DashboardContext';
import {
  Icon,
  OverflowMenuItem,
  tailwindOverride,
  Typography,
} from '@getsynapse/design-system';
import { showNotification as showSnackbarNotification } from '../../../../state/SnackbarNotification/SnackbarNotificationSlice';
import { useHistory } from 'react-router-dom';
import { PATHS } from '../../../../utils/constants';

export const DeleteDashboardOverflowMenuItem = () => {
  const dispatch = useAppThunkDispatch();
  const history = useHistory();
  const [deleteDashboardModalOpen, setDeleteDashboardModalOpen] =
    useState(false);

  const { dashboardId } = useContext(DashboardContext);

  const item = {
    label: intl.get('DASHBOARDS_LIST_PAGE.TABLE.ACTION.DELETE'),
    iconName: 'trash-outline',
    onSelect: () => {
      setDeleteDashboardModalOpen(true);
    },
    action: DASHBOARD_DETAIL_ACTIONS.DELETE,
  };

  const dashboardName = useSelector(
    (state: RootState) =>
      dashboardSelectors.selectDashboardById(state, dashboardId)?.name
  );

  const handleDelete = useCallback(async () => {
    const deletedDashboardName = dashboardName || '';
    try {
      await dispatch(deleteDashboard(dashboardId));
      history.push(PATHS.DASHBOARDS_LIST_PAGE);
      dispatch(
        showSnackbarNotification({
          notificationVariant: 'success',
          notificationTitle: intl.get(
            'DELETE_DASHBOARD_MODAL.SUCCESS_SNACKBAR_MESSAGE',
            { name: deletedDashboardName }
          ),
        })
      );
    } catch (error) {
      dispatch(
        showSnackbarNotification({
          notificationVariant: 'error',
          notificationTitle: intl.get(
            'DELETE_DASHBOARD_MODAL.ERROR_SNACKBAR_MESSAGE'
          ),
        })
      );
    }
  }, [dashboardId, dashboardName, dispatch, history]);

  return (
    <>
      <DeleteDashboardModal
        handleDelete={handleDelete}
        onCloseModal={() => setDeleteDashboardModalOpen(false)}
        shouldDisplayModal={deleteDashboardModalOpen}
        dashboardName={dashboardName || ''}
      />
      <OverflowMenuItem
        key={item.label}
        className='group flex items-center space-x-2'
        onSelect={item.onSelect}
        data-cy={`dashboard-${dashboardId}__actions-popover__${item.action}`}
      >
        <Icon
          name={item.iconName || ''}
          className={tailwindOverride(
            'fill-current text-primary group-hover:fill-current group-hover:text-secondary-darker group-active:text-neutral-white group-active:fill-neutral-white text-lg'
          )}
        />
        <Typography
          variant='label'
          className='group-active:text-neutral-white cursor-pointer'
        >
          {item.label}
        </Typography>
      </OverflowMenuItem>
    </>
  );
};
